'use client';

import { useAuthV2 } from '@/hooks/useAuthV2';
import { UserGroups } from '@/utils/types';

export function useIsStaff(): boolean {
  const { userGroups, userLoaded } = useAuthV2();
  if (!userLoaded) return false;
  return userGroups.some((g) => [UserGroups.STAFF, UserGroups.ADMIN].includes(g as UserGroups));
}
